import React, { FC } from 'react';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import { useButton } from '~Hooks/Entities/useButton';
import { Button } from '~Styles';
import useI18n from '~Translations';
import PersonIcon from '~Assets/icons/person.svg';

interface Props {
  /** Closes the modal entirely - there is nothing else this view can lead to. */
  onClose: () => void;
}

const NotOnboarded: FC<Props> = ({ onClose }) => {
  const { i18n } = useI18n();
  const isHandy = window.innerWidth <= 600;

  const btn = useButton({
    onClick: onClose,
  });

  return (
    <ModalWrapper
      padding={isHandy ? 'large' : '2xl'}
      isHandy={isHandy}
      header={{
        title: i18n('Loyalty.NotFullyOnboarded'),
        subtitle: i18n('Loyalty.NotFullyOnboardedSubtitle'),
        icon: PersonIcon,
      }}>
      <Button fluid {...btn}>
        {i18n('Loyalty.Close')}
      </Button>
    </ModalWrapper>
  );
};

export default NotOnboarded;
